import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { EXCLUDED_EVENTS } from '@app-core/constants/constants';
import { CommonHttpService } from '@app-core/services/common-http/common-http.service';
import { StorageService } from '@app-core/services/storage/storage.service';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CoachingConfigResolver implements Resolve<boolean> {
  constructor(private commonHttpService: CommonHttpService, private storageService: StorageService) {}

  public resolve(): Observable<boolean> {
    return this.commonHttpService.getFleetCoachingConfig().pipe(
      tap((res: any) => {
        const config = res?.value?.coachingConfig;
        const filteredEventTypes = config?.eventTypes?.filter((event) => !EXCLUDED_EVENTS.includes(event)) ?? [];
        const filteredEscalationEventTypes = config?.escalationEventTypes?.filter((event) => !EXCLUDED_EVENTS.includes(event)) ?? [];
        this.storageService.setStorageValue('coachingConfig', {
          ...config,
          eventTypes: filteredEventTypes,
          escalationEventTypes: filteredEscalationEventTypes,
        });
      }),
      catchError(() => of(false))
    );
  }
}
